import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { IconButton } from 'ui/button';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Hint } from './WorkflowWebhookEditor.styled';

export const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 0 ${spacing.threeQuarter};
  align-items: start;
  margin-top: ${spacing.half};
`;

export const WrapperJson = styled(Wrapper)`
  margin-top: ${spacing.half};
`;

export const InlineFormField = styled(FormField)`
  & + & {
    margin-top: ${spacing.quarter};
  }
  margin: ${spacing.quarter} 0;
`;

export const FieldHeader = styled(Hint)`
  width: ${pxToRem(290)};
`;

export const KeyValueInput = styled(InputText)`
  width: ${pxToRem(290)};
`;

export const DeleteButton = styled(IconButton)`
  margin-left: -${spacing.half};
  margin-top: ${spacing.quarter};
`;
